<ng-container *ngFor="let unit of units">
  <div class="tech-tab-add-unit" *ngIf="!unit.active && unit.canAdd">
    <button mat-icon-button type="button" [disabled]="isReadOnly()" (click)="onAdd(unit)">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="tech-tab-unit" *ngIf="unit.active">
    <h4>
      {{ unit.label }}
      <button
        *ngIf="unit.canDelete"
        mat-icon-button
        type="button"
        [disabled]="isReadOnly()"
        (click)="onDelete(unit)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </h4>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [required]="projectCreation"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="subTechnology"
                        [items]="allSubTechnologies"
                        [itemToLabel]="subTechToLabel"
                        placeholder="Sub-Technology"
                        tooltip="Identifies the sub-technology for Type {{unit?.id | lastLetter}} of the proposed
                        Storage installation, available options are: Ground Based - Container, Ground Based - Building."
                        error="Mandatory: Please select a value"
    ></digires-list-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="areaSize"
                       placeholder="Site Area (ha)"
                       error="Please enter a positive number"
                       tooltip="Identifies the site area for Type {{unit?.id | lastLetter}} of the proposed storage
                       installation, as measured in hectares (ha)."
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="description"
                        placeholder="Site Description"
                        tooltip="Identifies the site description (e.g. agricultural land) for Type
                        {{unit?.id | lastLetter}} of the proposed Storage installation."
    ></digires-text-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="batteryTechnology"
                        [items]="allBatteryTechnologies"
                        [itemToLabel]="batteryTechToLabel"
                        placeholder="Battery Technology"
                        tooltip="The type of Battery technology used for Type {{unit?.id | lastLetter}} of the proposed
                        Storage installation, for example Li Ion, NaS, Redox Flow etc."
    ></digires-list-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="batterySystem"
                        [items]="allBatterySystems"
                        [itemToLabel]="batterySystemToLabel"
                        placeholder="Battery System"
                        tooltip="The type of Battery system used for Type {{
        unit?.id | lastLetter
      }} of the proposed Storage installation: Containerised, Building."
    ></digires-list-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="duration"
                       placeholder="Storage Duration (hrs)"
                       tooltip="The duration in time (i.e. hours) that the the fully charged Storage system (BESS)
                       would take to fully release its charge when doing so at its maximum capacity."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="count"
                       placeholder="Number of Modules"
                       error="Please enter a positive number"
                       tooltip="The number of Type {{unit?.id | lastLetter}} Storage Modules that it is proposed to
                       install in this Project as set out in the preferred scenario in the financial model."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="capacity"
                       placeholder="Module Capacity (Wh)"
                       error="Please enter a positive number"
                       tooltip="The capacity (in Watt Hours (Wh)) for each individual Type {{unit?.id | lastLetter}}
                       Storage Module"
    ></digires-num-input>

    <digires-num-input [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="totalCapacity"
                       [readOnly]="true"
                       readOnlyReason="{{calculatedReadOnlyReason}}"
                       placeholder="Total Capacity per Module Type (MWh)"
                       tooltip="The total installed capacity of this type of Storage module that is calculated by
                       multiplying the installed capacity (Wh) of this model of Storage Module by the number of
                       modules of this type that it is proposed to install in this Project as set out in the preferred
                       scenario in the financial model and dividing by 1,000 to convert from Wh to MWh. This relates
                       to the total Storage capacity of this Type of Storage Module in the project. Installed Capacity
                       expressed in MegaWatt Hours (MWh) As the project evolves through the development process the
                       installed capacity may fluctuate if the Storage Module type is changed as the project matures
                       and more information is available to the project team, including new models coming to market."
    ></digires-num-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="moduleType"
                        [items]="allModuleTypes"
                        [itemToLabel]="moduleTypeToLabel"
                        placeholder="Module Type"
                        tooltip="The type of Storage Module that it is proposed to install in the project: 0.1C, 0.2C, 0.5C, 1C, 2C, 5C."
    ></digires-list-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="manufacturer"
                        placeholder="Module Manufacturer"
                        tooltip="Identifies the name of the manufacturer of the modules for Type {{
        unit?.id | lastLetter
      }} of the proposed Storage installation (e.g. Samsung, CATL, NGK)."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="inverterType"
                        placeholder="Inverter Type"
                        tooltip="Identifies the Type of the Inverters for Type {{
        unit?.id | lastLetter
      }} of the proposed Storage installation."
    ></digires-text-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="inverterCount"
                       placeholder="Number of Inverters"
                       error="Please enter a positive number"
                       tooltip="Identifies the number of Inverters for Type {{
        unit?.id | lastLetter
      }} of the proposed Storage installation."
    ></digires-num-input>
  </div>
</ng-container>
